import React, { Component } from "react";
import CoordinadorAdministrativoCalificacion, {
  ProcesoResultado
} from "../../../../types/CoordinadorAdministrativoCalificacion";
import { formatMoney, formatPercent } from "../../../helpers/formatters";
import { Button } from "reactstrap";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  calificaciones: CoordinadorAdministrativoCalificacion[];
  onExport: () => void;
  loading: boolean;
}

export default class GeneracionCoordinadorAdministrativoTable extends Component<
  Props
> {
  getRowStyle = (resultado: ProcesoResultado) => {
    switch (resultado) {
      case ProcesoResultado.ERROR:
        return { backgroundColor: "#f8d7da" };
      case ProcesoResultado.WARNING:
        return { backgroundColor: "#fffbdbff" };
      default:
        return {};
    }
  };

  render() {
    const { calificaciones } = this.props;

    if (!calificaciones || calificaciones.length === 0) {
      return null;
    }

    return (
      <>
        <div className="mb-1">
          <div className="row">
            <div className="col-6 pt-2">
              Compesaciones procesadas: {calificaciones.length} &nbsp; (Por
              pagar:{" "}
              {
                calificaciones.filter(
                  c => c.resultado !== ProcesoResultado.ERROR
                ).length
              }
              )
            </div>
            <div className="col-6 text-right">
              <Button
                color="secondary"
                onClick={this.props.onExport}
                disabled={this.props.loading}
                className="mr-2"
              >
                <FontAwesomeIcon icon={faFileExport} />
                {!this.props.loading ? " Exportar CSV" : " Espere..."}
              </Button>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-nowrap">
                        <span>Club</span>
                      </th>
                      <th className="text-nowrap">
                        <span>No. Emp.</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Coordinador</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Des. Meta</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Des. Real</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Var.</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Des. Alcance</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Checklist</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Comisión</span>
                      </th>
                      <th className="text-nowrap">
                        <span>Mensaje</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {calificaciones.map((cal, idx) => (
                      <tr key={idx} style={this.getRowStyle(cal.resultado)}>
                        <td>{cal.nombreClub}</td>
                        <td>{cal.numeroEmpleado}</td>
                        <td>{cal.coordinadorAdministrativo}</td>
                        <td className="text-right">{cal.metaDesercion}</td>
                        <td className="text-right">{cal.desercion}</td>
                        <td className="text-right">{cal.var}</td>
                        <td className="text-right">
                          {formatPercent(cal.calificacionDesercion)}
                        </td>
                        <td className="text-right">
                          {formatPercent(cal.calificacionChecklist)}
                        </td>
                        <td className="text-right">
                          {formatMoney(cal.montoComision)}
                        </td>
                        <td>{cal.mensaje}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
